import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import store from '@Store';
import StructureModel from '@Components/Results/structure/structure-model.service';
import StructureZoomService from '@Services/StructureZoom';
import Structure from '@Components/Results/structure/Structure';
import { openMultiStepReactionDialogForSingleReaction } from '@Pages/RetroSynthesis/MultiStepReactionDialog/actions';
import ReactionViewConnector from '@Components/Results/reactions/ReactionViewConnector';

export default class ReactionViewItemComponent extends React.Component {
  constructor(props) {
    super(props);

    this.zoomClasses = StructureZoomService.getZoomClasses('reactions') || [];
    this.goToReactionScheme = this.goToReactionScheme.bind(this);
  }

  goToReactionScheme() {
    const { reactionId, metadata } = this.props;

    if (!this.schemeLoading) {
      this.schemeLoading = true;
      store.dispatch(
        openMultiStepReactionDialogForSingleReaction({
          reactionId,
          databaseId: metadata?.databaseId,
          onClose: () => {
            this.schemeLoading = false;
          },
        })
      );
    }
  }

  render() {
    const { zoom, isFirst, isProduct, displayTransferTo, metadata, structure, structureTitle, showToolbar, isLast, trailingArrow } =
      this.props;
    const zoomClass = this.zoomClasses?.[zoom];
    const detailsId = get(structure, 'details.id');
    const molImagePath = get(structure, 'molImage.path');

    return (
      <span className="reactions-item-wrapper">
        {!isFirst ? <ReactionViewConnector icon="plus" /> : null}
        {isProduct && isFirst ? (
          <ReactionViewConnector icon="arrow" displayTransferTo={displayTransferTo} transferToClick={this.goToReactionScheme} />
        ) : null}
        {isProduct || detailsId || molImagePath ? (
          <Structure
            metadata={metadata}
            structure={structure}
            title={structureTitle}
            zoom={zoom}
            showToolbar={showToolbar}
            className={`substances-item-wrapper substances-item-wrapper--${isProduct ? 'product' : 'reactant'} ${zoomClass}`}
          />
        ) : null}
        {trailingArrow && isLast ? <ReactionViewConnector icon="arrow" /> : null}
      </span>
    );
  }
}

ReactionViewItemComponent.defaultProps = {
  displayTransferTo: false,
};

ReactionViewItemComponent.propTypes = {
  // main data
  structure: PropTypes.instanceOf(StructureModel).isRequired,
  isProduct: PropTypes.bool,
  trailingArrow: PropTypes.bool,
  // secondary data
  metadata: PropTypes.object,
  structureTitle: PropTypes.string,
  zoom: PropTypes.number,
  // loop props
  isFirst: PropTypes.bool,
  isLast: PropTypes.bool,
  showToolbar: PropTypes.bool,
  reactionId: PropTypes.string.isRequired,
  displayTransferTo: PropTypes.bool,
};
